module.exports = __webpack_public_path__ + "assets/img/63ec653ae79a54e8c7542f2d50303c3b.svg";